<span>UTM Zone {{currentUTMZone()}}:{{currentCoordinates()}}</span>
